// Fuente única de verdad para el estado de una actividad de protocolo.
// Usado por GestorActividades, ActivityManager y SubActivityManager_v2 para
// que el color, el texto y el punto de estado nunca queden desincronizados
// entre el encabezado de pasos, la tarjeta de actividad y la tabla.
export const ACTIVITY_STATES = {
  Created: {
    label: "Pendiente",
    color: "default",
    dot: "#bfbfbf",
    bg: "#fafafa",
    border: "#d9d9d9",
  },
  Started: {
    label: "En curso",
    color: "warning",
    dot: "#faad14",
    bg: "#fffbe6",
    border: "#faad14",
  },
  Completed: {
    label: "Completada",
    color: "success",
    dot: "#52c41a",
    bg: "#f6ffed",
    border: "#52c41a",
  },
  Skipped: {
    label: "Omitida",
    color: "success",
    dot: "#52c41a",
    bg: "#f6ffed",
    border: "#52c41a",
  },
  Terminated: {
    label: "Finalizada",
    color: "success",
    dot: "#52c41a",
    bg: "#f6ffed",
    border: "#52c41a",
  },
};

export const TERMINAL_STATES = ["Completed", "Skipped", "Terminated"];

export const isTerminalState = (state) => TERMINAL_STATES.includes(state);

export const getActivityStateConfig = (state) =>
  ACTIVITY_STATES[state] || ACTIVITY_STATES.Created;
